import React from "react";

import "./user-analytics-v2.styles.scss";

const UserAnalyticsV2 = () => (
  <div className="home-component">
    <iframe
    className="report"
      // src="https://datastudio.google.com/embed/reporting/e1557321-7daf-4a8f-bd16-45d04022ecc7/page/p_ui1i42dsxc"
      src="https://lookerstudio.google.com/embed/reporting/9d417277-a1d1-4084-861c-ac9a9ae96067/page/nyZ5D"
      title="User Analytics"
    />
  </div>
);

export default UserAnalyticsV2;
